import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const DcfwNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="dcfw" />;
};
